var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "checkbox-field",
    _vm._b(
      {
        attrs: { value: _vm.proxyValue },
        on: { input: _vm.handleInput },
        scopedSlots: _vm._u(
          [
            {
              key: "additional-content",
              fn: function () {
                return [_vm._t("additional-content")]
              },
              proxy: true,
            },
            {
              key: "label",
              fn: function () {
                return [_vm._t("label")]
              },
              proxy: true,
            },
            {
              key: "field-description",
              fn: function () {
                return [_vm._t("field-description")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "checkbox-field",
      { ..._vm.$attrs, ..._vm.$props },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }